let index = 0;
let intervalRef;
let tasks = {};
let theValueCount= 0;
let intervalTime = 0;
function transformer(preValue, params, next) {
  if (params) {
    try {
        if(intervalRef){
            clearInterval(intervalRef);
        }
      let params1 = JSON.parse(params);
      let { valueCount, taskId, global_intervalTime } = params1;  //{valueCount:3,taskId:100}
      if(global_intervalTime){
          let t = Number(global_intervalTime);
          if(!Number.isNaN(t)){
            intervalTime = Math.max(intervalTime, t);
          }
      }
      if(valueCount){
        theValueCount = Math.max(valueCount, theValueCount)
      }
      tasks[taskId] = {preValue, params, next};
      let taskRunner = () => {
        index++;
        if(index==theValueCount){
            index = 0;
        }
        
        for (const key in tasks) {
          if (tasks.hasOwnProperty(key)) {
            const {preValue, params, next} = tasks[key];
            let params1 = JSON.parse(params);
            let { valueCount } = params1; 
            try {
                next.call(this, preValue[valueCount?Math.min(index, valueCount-1, preValue.length-1):Math.min(index, preValue.length-1)])
            } catch (error) {
                console.error(error);
                
            }
            
          }
        }
      };
      intervalRef = setInterval(taskRunner, intervalTime||1000);
      taskRunner();
    } catch (error) {
        console.error(error);
        return preValue[0];
    }
    return preValue[0];
  } else {
    return preValue[0];
  }
}

export { transformer };
